export const taskQuizOptions = {
	type: 'object',
	required: [
		'content',
		'correct'
	],
	properties: {
		content: {
			type: 'string'
		},
		correct: {
			type: 'boolean'
		}
	},
	errorMessage: {
		required: 'validationFieldRequired',
		properties: {
			content: 'validationFieldRequired',
			correct: 'validationFieldRequired'
		}
	}
};
